module.exports = __webpack_public_path__ + "img/jd_plain_small.1f569dfd.png";